export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_SWITCH_ORGANIZATION_ID = "setSwitchOrganizationId";
export const SET_ERROR = "setError";
export const SKIP_CHANGE_PASSWORD = "skipChangePassword";
export const SET_BRANDING = "setBranding";
export const REFRESH = "refresh";
export const SET_AVATAR = "setAvatar";
export const SET_TABLE_DATA = "setTableData";